import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const fileUrl = (path) => (path ? `${API_BASE}/files/${path}` : null);

// Normalize any stored file URL/path to the CURRENT backend origin so the
// same-origin session cookie is sent (fixes cross-origin 401 on protected /api/files).
export const resolveFileUrl = (u) => {
  if (!u) return null;
  const marker = "/api/files/";
  const i = u.indexOf(marker);
  if (i !== -1) return fileUrl(u.slice(i + marker.length));
  return u;
};

export const avatarSrc = (u) =>
  u?.avatar_path
    ? fileUrl(u.avatar_path)
    : u?.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(u?.name || "D")}&background=1a1424&color=D4AF37`;

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric", timeZone: "Asia/Singapore" }) : "";
export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: "Asia/Singapore" })
    : "";
export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "";

export const googleCalUrl = ({ title, startISO, endISO, details = "", location = "Darkchata" }) => {
  const fmt = (iso) => new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
  const dates = `${fmt(startISO)}/${fmt(endISO)}`;
  const p = new URLSearchParams({ action: "TEMPLATE", text: title || "Darkchata", dates, details, location });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

// Interpret a datetime-local string as Asia/Singapore (+08:00) and store absolute UTC ISO.
export const sgtToISO = (localStr) => {
  if (!localStr) return null;
  const s = localStr.length === 16 ? `${localStr}:00` : localStr;
  return new Date(`${s}+08:00`).toISOString();
};
// Convert a UTC ISO instant back to an SGT wall-clock datetime-local value.
export const isoToSgtLocal = (iso) => {
  if (!iso) return "";
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Singapore", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date(iso)).reduce((a, x) => { a[x.type] = x.value; return a; }, {});
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};
export const money = (n) => `S$${Number(n).toFixed(Number(n) % 1 === 0 ? 0 : 2)}`;
